<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>AMA管理</span>
				<p style="margin-top: 10px"
					>显示规则：已经确定已上架的，并且在开始和结束时间之内；</p
				>
				<p
					>排序规则：优先序号，越低则优先显示，序号相同则后创建的显示在前面；</p
				>
			</div>
			<div style="margin-top: 20px">
				<el-form :inline="true" :model="searchInfo" class="demo-form-inline">
					<el-form-item label="标题">
						<el-input
							class="custom_input_180"
							v-model="searchInfo.title"
							placeholder=""
						>
						</el-input>
					</el-form-item>

					<el-form-item label="状态">
						<el-select
							class="custom_input_120"
							v-model="searchInfo.is_show"
							placeholder=""
						>
							<el-option label="已上架" value="1"></el-option>
							<el-option label="草稿箱" value="0"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="searchBtn">查询</el-button>
						<el-button type="primary" @click="reset">重置</el-button>
						<el-button type="primary" @click="add">添加</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import tablec from "./tablec.vue";
import ExportExcel from "../../../components/ExportExcel.vue";
import {
	getInformationList,
	getCategoryList,
	getLabelList,
	getBannerList,
} from "@/api/article";
import { searchMixin } from "@/utils/searchMixin.js";
export default {
	mixins: [searchMixin],
	components: { tablec, ExportExcel },
	name: "",
	data() {
		return {
			tableData: [],
			total: 0,
			categoryList: [],
			labelList: [],
			searchInfo: {
				title: "",
				is_show: "",
				type: "11",
				page: 1,
				size: 10,
			},
		};
	},
	created() {
		this.getDataList();
	},
	methods: {
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		add() {
			this.$router.push({
				path: "/recommend/bannerdetail",
				query: { type: "edit", channel: "ama" },
			});
		},
		getDataList() {
			let _data = Object.assign(this.searchInfo, {});
			sessionStorage.setItem("bannerListKey_m_ama", JSON.stringify(_data));
			const that = this;
			getBannerList(this.searchInfo)
				.then((res) => {
					console.log(res);
					if (res.code == 200) {
						that.tableData = res.data.list;
						that.total = res.data.total;
					} else {
						that.tableData = [];
						that.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
		reset() {
			this.searchInfo.title = "";
			this.searchInfo.is_show = "";
			this.searchInfo.type = "1";
			this.searchInfo.page = 1;
			this.searchInfo.size = 10;
			this.getDataList();
		},
	},
};
</script>

<style scoped></style>
